import { css, SerializedStyles } from '@emotion/react';

import styled from '@emotion/styled';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { withConfig } from 'src/withConfig';



interface EventListPropsType {

    variant: DefaultComponentVariantType | null;

}



const setEventListWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            display: flex;

            flex-flow: column nowrap;

            gap: ${theme.star.gap.medium};

            padding: ${theme.star.padding.medium};

            background-color: ${theme.star.eventsTableColors.bgColor};

            @media ${theme.star.mediaQuery.tablet} {

                margin: 0 8px;

                border-radius: 0 0 ${theme.star.radius.medium} ${theme.star.radius.medium};

            }

        `;

    }

    return css``;

};



export const EventListWrapper = withConfig(theme => styled('section', { label: 'EventListWrapper' })<EventListPropsType>`

    ${({ variant }): SerializedStyles => setEventListWrapper(variant, theme)}

    font-size: ${theme.star.fontSize.xRegular};

    overflow: hidden;

`);



const setCompetitionWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            display: flex;

            flex-flow: column nowrap;

            gap: ${theme.star.gap.medium};

        `;

    }

    return css``;

};



export const CompetitionWrapper = withConfig(theme => styled('div', { label: 'CompetitionWrapper' })<EventListPropsType>`

    ${({ variant }): SerializedStyles => setCompetitionWrapper(variant, theme)}

`);



const setEventsListGroupWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            display: flex;

            flex-flow: column nowrap;

            gap: ${theme.star.gap.small};

        `;

    }

    return css``;

};



export const EventsListGroupWrapper = withConfig(theme => styled('div', { label: 'EventsListGroupWrapper' })<EventListPropsType>`

    ${({ variant }): SerializedStyles => setEventsListGroupWrapper(variant, theme)}

`);





const setEventsListCompetitionGroupItemWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            display: flex;

            flex-flow: column nowrap;

            gap: ${theme.star.gap.medium};

        `;

    }

    return css``;

};



export const EventsListCompetitionGroupItemWrapper = withConfig(theme => styled('div', { label: 'EventsListCompetitionGroupItemWrapper' })<EventListPropsType>`

    ${({ variant }): SerializedStyles => setEventsListCompetitionGroupItemWrapper(variant, theme)}

`);

